import { z } from "zod";

export const linkToken = z.string().regex(/^[A-Za-z0-9_-]{43}$/);
export const linkPublicKey = z.string().regex(/^[A-Za-z0-9_-]{87}$/);
export const linkRequestSchema = z.object({
  version: z.literal(1), flowId: linkToken, origin: z.string().url().max(256),
  expiresAt: z.number().int().positive(), targetPublicKey: linkPublicKey,
  secretHash: linkToken,
}).strict();
export const linkQrSchema = linkRequestSchema.extend({ secret: linkToken }).strict();
export const linkPacketSchema = z.object({
  senderPublicKey: linkPublicKey, accountXid: z.string().regex(/^[A-Za-z0-9_-]{1,64}$/),
  identityPublicKey: linkPublicKey, iv: z.string().regex(/^[A-Za-z0-9_-]{16}$/),
  ciphertext: z.string().regex(/^[A-Za-z0-9_-]+$/).min(40).max(2048),
  signature: z.string().regex(/^[A-Za-z0-9_-]{86}$/),
}).strict();
export type LinkRequest = z.infer<typeof linkRequestSchema>;
export type LinkQr = z.infer<typeof linkQrSchema>;
export type LinkPacket = z.infer<typeof linkPacketSchema>;
const encode = (value: unknown) => new TextEncoder().encode(JSON.stringify(value));
// Canonical arrays, not object insertion order. Every routing/binding field is authenticated.
export const linkContext = (r: LinkRequest) => ["link.device-pair.v1", r.flowId, r.origin, r.expiresAt, r.targetPublicKey, r.secretHash];
export const linkAad = (r: LinkRequest, p: Omit<LinkPacket, "ciphertext" | "signature">) => encode([...linkContext(r), p.senderPublicKey, p.accountXid, p.identityPublicKey, p.iv]);
export const linkProof = (r: LinkRequest, p: Omit<LinkPacket, "signature">) => encode([...linkContext(r), p.senderPublicKey, p.accountXid, p.identityPublicKey, p.iv, p.ciphertext]);
